import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterExpenses } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import {saveAs} from 'file-saver';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-creditos',
  templateUrl: './creditos.component.html',
  styleUrls: ['./creditos.component.css']
})
export class CreditosComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    public datepipe: DatePipe,
    private modalService: NgbModal
  ) { }

  public currentUser: Auth;
  public expenses: any;

  queryDate: Date;
    
  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getGetExpensesBalance(this.currentUser.token.assignorGuid,(page-1),+this.showItem)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.expenses = response.result.items;
        this.totalItems = response.result.totalItems;     
        this.queryDate = new Date();        
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  exportExcel(){
  var result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const excelService = new ExcelService();
  const worksheets = new Array<WorksheetData>();
  const ws = new WorksheetData();
  ws.worksheetTitle = 'creditos_despesas_' + date[2] + '-' + date[1] + '-' + date[0];
  ws.worksheetHeaders = ['Destino','Data e hora','Valor'];
  ws.WorksheetRows = [];

  this.relatorioService.getGetExpensesBalance(this.currentUser.token.assignorGuid,0,+this.totalItems)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.items;      
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.receipter);
        lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss'));
        lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
        ws.WorksheetRows.push(lr);
      });

      worksheets.push(ws);

      // let filter = '';
      // filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
      
      excelService.generateExcelReport('Creditos de Despesas', worksheets, null).xlsx
      .writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, ws.worksheetTitle + '.xlsx');
      });

    }
  },
  error => {
    this.alertService.error('Ocorreu um erro ao paginar relatorio');
  });
}

exportPdf(){
  let result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const pdfData = new PdfData();
  pdfData.PdfTitle = 'creditos_despesas_' + date[2] + '-' + date[1] + '-' + date[0];
  pdfData.PdfHeaders = ['Destino','Data e hora','Valor',''];
  pdfData.PdfRows = [];

  this.relatorioService.getGetExpensesBalance(this.currentUser.token.assignorGuid,0,+this.totalItems)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.items;       
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.receipter);
        lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm:ss'));
        lr.push('R$');
        lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
        pdfData.PdfRows.push(lr);
      });

      const pdfService = new PdfService();
      pdfService.generatePdfReport('Creditos de Despesas',pdfData,null,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
        saveAs(blob, pdfData.PdfTitle + '.pdf');
      });

    } else {
      this.alertService.error(response.message);
    }
  },
  error => {
    this.alertService.error(
      'Ocorreu um erro ao paginar o relatorio'
    );
  });
}
}

